import api from './api';

const unwrap = (res) => res.data?.data ?? res.data;
const clinicOrderFormsService = {
  list: () => api.get('/admin/clinic-order-forms').then(unwrap),
  save: (id, draft) => api.put(`/admin/clinic-order-forms/${id}`, draft).then(unwrap),
  preview: (id, draft) => api.post(`/admin/clinic-order-forms/${id}/preview`, draft, { responseType: 'blob' }).then(res => res.data),
};
export default clinicOrderFormsService;
